routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.orderDetail', {
      url: "orderDetail/{orderId}",
      template: `<order-detail sh-ctrl="shCtrl"></order-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/orders/order-detail/order-detail.config.js
 **/